import { AfterViewInit, Directive, ElementRef, Renderer2 } from '@angular/core';

import { AccountService } from '../services/account.service';
import { BaseAuthorizationDirective } from './base-authorization.directive';

@Directive({
  selector: '[itl-authorize]',
})
export class AuthorizationDirective extends BaseAuthorizationDirective implements AfterViewInit {
  constructor(elementRef: ElementRef, renderer: Renderer2, accountService: AccountService) {
    super(accountService, elementRef, renderer);
  }

  async ngAfterViewInit() {
    await super.setVisibility();
  }
}
